import {Component, Prop, Vue} from "vue-property-decorator";
import flatPickr from "vue-flatpickr-component";
import {BallPulseLoader} from "vue-loaders";
import VueSimpleSpinner from "vue-simple-spinner";
import UploadControl from "@/componentsReusable/UploadControl.vue";
import {HTTP} from "@/utils/httpCommonUtil";
import {AppEntityType} from "@/enums/AppEntityType";
import {UserRoleEnum} from "@/enums/userRolesEnum";
import GenericModal from '@/componentsReusable/genericModal.vue';
import FacilityCredentialDocumentInformation
  from "@/components/facility/cards/credentialdocument/FacilityCredentialDocumentInformation";

@Component(
  {
    components: {
      flatPickr,
      BallPulseLoader,
      VueSimpleSpinner,
      UploadControl,
      GenericModal,
      FacilityCredentialDocumentInformation
    },
  }
)
export default class FacilityCredentialDocument extends Vue {

  @Prop({type: [String, Number], required: true})
  facilityId!: string|number;

  loadingCounter = 0;
  facilityCredentialDocument: any = this.resetAttachedDocument();
  showConfirmationModal = false;
  pendingDeleteId = null;

  get isAuthorizedToDelete () : boolean {
    return this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER, UserRoleEnum.CREDENTIALER, UserRoleEnum.ACCOUNTANT]);
  }

  async getFacilityCredentialDocument () {
    this.loadingCounter++;
    try {
      const response = await HTTP.get(`/api/attachments/types/${AppEntityType.FACILITY_CREDENTIAL}/entities/${this.facilityId}`);
      if (!response.data || !response.data.data) {
        throw new Error("Error retrieving Facility Credential Document.");
      }
      let freshFacilityDocuments = response.data.data;
      freshFacilityDocuments.forEach( (facilityDocument: any) => {
        facilityDocument.isEditing = false;
        facilityDocument.isNew = false;
      });
      if (freshFacilityDocuments[0]) {
        this.facilityCredentialDocument = freshFacilityDocuments[0];
      } else {
        this.resetAttachedDocument();
      }
    } catch (err) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred retrieving Facility Documents.'
      });
    } finally {
      this.loadingCounter--;
    }
  }

  resetAttachedDocument() {
    this.facilityCredentialDocument = {
      id: null,
      name: '',
      s3Key: '',
      entityId: null,
      uploadedOn: null,
      uploadedBy: null,
      employeeName: '',
    };
  }

  async associateUploadedFile (s3FilePath: string, fileName: string) {
    try {
      this.loadingCounter++;
      const response = await HTTP.post('/api/attachment/', {
        "entityId": this.facilityId,
        "entityType": AppEntityType.FACILITY_CREDENTIAL,
        "attachmentName": fileName,
        "s3Key": s3FilePath
      });

      if (!response.data || !response.data.success) {
        throw new Error("Error associating uploaded file.");
      }
    } catch (err) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred saving uploaded file attachment.'
      });
    } finally {
      this.loadingCounter--;
      await this.getFacilityCredentialDocument();
    }
  }

  async deleteConfirmed (id: any) {
    this.showConfirmationModal = false;
    await this.deleteCredentialDocument(this.pendingDeleteId, true);
  }

  async deleteCredentialDocument (id: any, bypassDeleteConfirmation: boolean = false ) {
    if (!bypassDeleteConfirmation) {
      // Show Delete Confirmation Modal
      this.showConfirmationModal = true;
      this.pendingDeleteId = id;
      return;
    } else {
      this.pendingDeleteId = null;
    }

    try {
      await HTTP.delete(`/api/attachments/${id}`);
      await this.getFacilityCredentialDocument();
    } catch (err) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred deleting document'
      });
    }
  }

  async openFacilityDocument (s3Key: string) {

    const url = '/api/s3/signed-url/get';
    try {
      const response = await HTTP.get(url + `?s3key=${s3Key}`);
      if (!response.data || !response.data.data) {
        throw new Error("Error getting attachment.");
      }
      window.open(response.data.data, '_blank');
    } catch(err) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred saving uploaded document.'
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/facility/cards/credentialdocument/FacilityCredentialDocument.ts